import { Deserializable } from '../../protocols/deserializable';
import { UpdateEmployerAddressSubmissionData } from './update-employer-address-submission-data';

export class UpdateEmployerAddressSubmission implements Deserializable {
  public new!: UpdateEmployerAddressSubmissionData;
  public previous!: UpdateEmployerAddressSubmissionData;

  public onDeserialize(): void {
    if (!!this.new) {
      this.new = window.injector.Deserialize.instanceOf(UpdateEmployerAddressSubmissionData, this.new);
    }

    if (!!this.previous) {
      this.previous = window.injector.Deserialize.instanceOf(UpdateEmployerAddressSubmissionData, this.previous);
    }
  }
}
